import TeamsManagerContainer from "../../container/admin/teams-manager";

const TeamsManager = () => {
    return <TeamsManagerContainer />;
};

export default TeamsManager;